module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1115.ff98923c.png";